import { CAMPAIGN_ENUM_TYPES, CAMPAIGN_SUBTYPES_ENUM } from "shared/constants";
import type { BuilderChannel, ChannelConfig } from "./channelConfig";

const registry = new Map<BuilderChannel, ChannelConfig>();

export const registerChannelConfig = (config: ChannelConfig): void => {
  registry.set(config.channel, config);
};

export const hasChannelConfig = (channel: BuilderChannel): boolean => registry.has(channel);

export const getChannelConfig = (channel: BuilderChannel): ChannelConfig => {
  const config = registry.get(channel);
  if (!config) {
    throw new Error(`No ChannelConfig registered for builder channel "${channel}"`);
  }
  return config;
};

export const resolveBuilderChannel = ({
  channel,
  subtype,
}: {
  channel?: string | null;
  subtype?: string | null;
}): BuilderChannel | null => {
  if (subtype === CAMPAIGN_SUBTYPES_ENUM.ADM) return "ADM";
  if (subtype === CAMPAIGN_SUBTYPES_ENUM.EDDM) return "EDDM";
  if (channel === CAMPAIGN_ENUM_TYPES.HANDTOHAND) return "H2H";
  if (channel === CAMPAIGN_ENUM_TYPES.LETTERBOX) return "D2D";
  return null;
};
